import React, { useState } from 'react'
import { connect } from 'react-redux'
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown
} from 'reactstrap'
import PropTypes from 'prop-types'
import UserAvatar from 'react-user-avatar'
import { useTranslation } from 'react-i18next'

import history from '../../helpers/History'
import themeActions, { THEMES } from '../../theme/actions'

const UserDropdownMenu = ({
  currentTheme,
  dispatch,
  email = null
}) => {
  const { t } = useTranslation('ApplicationLayout')
  const [showThemes, setShowThemes] = useState(false)

  const handleThemeChange = (theme) => {
    dispatch(themeActions.setTheme(theme))
    setShowThemes(false)
  }

  return (
    <>
      {email === null ? (
        <div>...</div>
      ) : (
        <UncontrolledDropdown nav inNavbar>
          <DropdownToggle
            caret
            className="position-relative p-0 d-flex align-items-center"
            id="user-menu"
            nav
          >
            <UserAvatar
              className="me-2"
              name={email}
              size="39"
            />
          </DropdownToggle>
          <DropdownMenu end>
            <DropdownItem
              toggle={false}
              onClick={() => setShowThemes(!showThemes)}
            >
              <i className="bi bi-palette me-2" />
              {t('AppNavbar.UserDropdownMenu.options.theme')}
              <i className={`bi bi-chevron-${showThemes ? 'up' : 'down'} ms-2`} />
            </DropdownItem>

            {showThemes && (
              <div className="ps-3">
                {THEMES.map((theme) => (
                  <DropdownItem
                    key={theme}
                    name={`theme-${theme}`}
                    onClick={() => handleThemeChange(theme)}
                    className={currentTheme === theme ? 'active' : ''}
                  >
                    {currentTheme === theme && (
                      <i className="bi bi-check me-2" />
                    )}
                    {t(`AppNavbar.UserDropdownMenu.themes.${theme}`)}
                  </DropdownItem>
                ))}
              </div>
            )}

            <DropdownItem divider />
            <DropdownItem
              className="text-danger"
              name="logout_entry"
              onClick={() => history.push('/logout')}
            >
              {t('AppNavbar.UserDropdownMenu.options.logout')}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      )}
    </>
  )
}

UserDropdownMenu.propTypes = {
  currentTheme: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  email: PropTypes.string
}

const mapStateToProps = ({
  authentication: {
    email
  },
  theme: {
    current: currentTheme
  }
}) => ({
  currentTheme,
  email
})

export default connect(mapStateToProps)(UserDropdownMenu)
